import React from 'react';

/**
 * Compact pill-style tab switcher: muted track, active tab raised in white.
 * tabs: [{ id, label, icon? }]
 */
const SegmentedTabs = ({ tabs, value, onChange, ariaLabel, className = '', fullWidth = false }) => (
  <div
    role="tablist"
    aria-label={ariaLabel}
    className={`${fullWidth ? 'flex w-full' : 'inline-flex w-fit'} h-9 max-w-full items-center overflow-x-auto rounded-xl bg-zinc-200/50 dark:bg-zinc-800/50 backdrop-blur-md p-[3px] border border-zinc-200/60 dark:border-white/10 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden text-zinc-600 dark:text-zinc-300 ${className}`}
  >
    {tabs.map(({ id, label, icon: Icon }) => {
      const active = value === id;
      return (
        <button
          key={id}
          type="button"
          role="tab"
          aria-selected={active}
          onClick={() => onChange(id)}
          className={`inline-flex h-full flex-1 items-center justify-center gap-1.5 whitespace-nowrap rounded-lg border border-transparent px-3 py-1 text-sm font-medium transition-all duration-200 focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-[#DD0000]/20 ${
            active ? 'bg-white/95 dark:bg-zinc-700/90 text-zinc-950 dark:text-white shadow-xs backdrop-blur-xs border border-white/60 dark:border-white/10' : 'text-zinc-600 dark:text-zinc-400 hover:text-zinc-950 dark:hover:text-white'
          }`}
        >
          {Icon && <Icon className="size-4 shrink-0" />}
          {label}
        </button>
      );
    })}
  </div>
);

export default SegmentedTabs;
